import createTextStep from './form/createTextStep';
import createDispatchSettingStep from './form/createDispatchSettingStep';

const formSteps = {
  create_dispatch: [createDispatchSettingStep({}), createTextStep({})],
};

export default formSteps;
